import { router } from "@inertiajs/react"
import { collapsePath } from "./params"
import { identifyUser, initAnalytics, resetUser, setContext, trackEvent, trackScreen } from "./analyticsService"

export { trackEvent } from "./analyticsService"
export { labelText, toEventKey, toEventValue } from "./params"

// Keeps analytics in step with Inertia: started from the first page's props, the operator identified or
// forgotten as they sign in and out, the organization and app of the page on every event, and one
// screen_view per visit. Called once, before the app renders, so the first page's navigate is caught.
//
// `navigate` fires for the first page and every visit to a new URL (not for a redirect back to the same
// page, which is not a new screen). `success` also fires after a form on the same page, and keeps the
// context current when a save changes it.
export function startAnalytics() {
  const sync = (page) => {
    const props = page.props || {}

    initAnalytics(props.analytics)
    setContext(
      {
        organization_id: props.organization?.id ?? null,
        app_id: props.app?.id ?? null,
        page_path: collapsePath(page.url),
      },
      page.component,
    )

    if (props.current_operator?.id) {
      identifyUser(props.current_operator)
    } else {
      resetUser()
    }
  }

  router.on("navigate", (event) => {
    sync(event.detail.page)
    trackScreen(event.detail.page.component)
  })
  router.on("success", (event) => sync(event.detail.page))
}

// An Inertia `onSuccess` that records `name` only if the save really happened. A refused write in this
// console comes back as a redirect with an `alert` flash (a non-owner, a failed retry), which Inertia
// still calls a success; validation errors never reach onSuccess at all. `params` may be a function of
// the new page. `then` is the call site's own onSuccess, run after.
export const onSaved = (name, params = {}, then) => (page) => {
  if (!page?.props?.flash?.alert) trackEvent(name, typeof params === "function" ? params(page) : params)
  then?.(page)
}
